// extracted by mini-css-extract-plugin
export default {"BestRatedBooks":"BestRatedBooks_BestRatedBooks__Mt07+","List":"BestRatedBooks_List__YhN1P"};